import styles from "./index.module.css";
import InfoIcon from "../../core/form/images/info.svg?react";
import { Typography } from "@mui/material";
import i18nPackage from "../../i18n/i18n";
import { forwardRef } from "react";

type GuideProps = {
	src: string;
	/**For screen readers */
	iframeTitle: string;
	description: string;
	title?: string;
	className?: string;
	videoClassName?: string;
};

const Guide = forwardRef<HTMLDivElement, GuideProps>(function Guide(
	{ src, iframeTitle, className, description, videoClassName, title = i18nPackage.t("beforeQuiz.tip") },
	ref,
) {
	return (
		<div className={`${styles.guideContainer} ${className ?? ""}`} ref={ref}>
			<div className={styles.guideTextWrapper}>
				<div className={styles.guideTitleWrapper}>
					<InfoIcon fill={"#42296E"} width={20} height={20} />
					<Typography className={styles.guideTitle}>{title}</Typography>
				</div>
				<Typography className={styles.guideDescription}>{description}</Typography>
			</div>

			<iframe
				role="video"
				title={iframeTitle}
				src={src}
				allowFullScreen
				loading="lazy"
				className={`${styles.guideVideo} ${videoClassName ?? ""}`}
			/>
		</div>
	);
});

export default Guide;
